<template>
  <!-- NOTE (TEMPLATE) to show the topics list -->

  <div class="animated fadeIn">
    <b-card v-if="$router.currentRoute.path == '/admin/topics'">
      <b-tabs pills>
        <b-tab title="رسته‌ها" active>
          <!-- NOTE (b-addRasteh) to add new "rasteh" to the table of "rasteh" -->
          <b-button variant="success" @click="openAdd1()" class="my-2"
            ><strong>افزودن رسته +</strong></b-button
          >
          <v-row
            class="header-box btn-radius pa-1 ps-2"
            style="margin: 0 1px 25px"
          >
            <v-col>
              <h4 style="margin-top: 9px">رسته‌ها</h4>
            </v-col>
            <v-col>
              <v-btn
                class="bc-primary text-white btn-radius float-end"
                width="200"
                height="45"
                elevation="0"
                :disabled="isBusy1 || !items1.length"
                @click="$refs.table1.$el.click()"
              >
                <span class="fs-small">
                  خروجی اکسل

                  <v-icon>$Excel</v-icon></span
                >
              </v-btn>
              <vue-excel-xlsx
                v-show="false"
                ref="table1"
                :data="items1"
                :columns="excelFields"
                :filename="'لیست رسته‌ ها'"
                :sheetname="currentDate"
              >
                دریافت اکسل
              </vue-excel-xlsx>
            </v-col>
          </v-row>
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="filter1"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <!-- NOTE (b-delete) to delete the text of the search bar -->
                <b-button
                  :disabled="!filter1"
                  @click="filter1 = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-rasteh) to show the "rasteh" list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields1"
            :items="items1"
            :current-page="currentPage1"
            :per-page="perPage1"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="isBusy1"
            :filter="filter1"
            @filtered="onFiltered1"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage1 * (currentPage1 - 1) + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  width: 150px;
                  margin: auto;
                "
              >
                <!-- NOTE (b-editRasteh) to edit rasteh -->
                <b-button
                  variant="warning"
                  style="width: 100%"
                  @click="openEdit1(data.item)"
                  >ویرایش</b-button
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage1"
            :total-rows="totalRows1"
            :per-page="perPage1"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
        <b-tab title="موضوعات">
          <!-- NOTE (b-addSubject) to add new subject -->
          <b-button variant="success" @click="openAdd2()" class="my-2"
            ><strong>افزودن موضوع جدید +</strong></b-button
          >
          <v-row
            class="header-box btn-radius pa-1 ps-2"
            style="margin: 0 1px 25px"
          >
            <v-col>
              <h4 style="margin-top: 9px">موضوع ها</h4>
            </v-col>
            <v-col>
              <v-btn
                class="bc-primary text-white btn-radius float-end"
                width="200"
                height="45"
                elevation="0"
                :disabled="isBusy2 || !items2.length"
                @click="$refs.table2.$el.click()"
              >
                <span class="fs-small">
                  خروجی اکسل

                  <v-icon>$Excel</v-icon></span
                >
              </v-btn>
              <vue-excel-xlsx
                v-show="false"
                ref="table2"
                :data="items2"
                :columns="excelFields2"
                :filename="'لیست موضوع ها'"
                :sheetname="currentDate"
              >
                دریافت اکسل
              </vue-excel-xlsx>
            </v-col>
          </v-row>
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="filter2"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <!-- NOTE (b-delete) to delete the text of the search bar -->
                <b-button
                  :disabled="!filter2"
                  @click="filter2 = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-subjects) to show the subjects list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields2"
            :items="items2"
            :current-page="currentPage2"
            :per-page="perPage2"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="isBusy2"
            :filter="filter2"
            @filtered="onFiltered2"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage2 * (currentPage2 - 1) + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  width: 150px;
                  margin: auto;
                "
              >
                <!-- NOTE (b-editSubject) to edit subject -->
                <b-button
                  style="width: 100%"
                  variant="warning"
                  @click="openEdit2(data.item)"
                  >ویرایش</b-button
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage2"
            :total-rows="totalRows2"
            :per-page="perPage2"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
        <b-tab title="محورها">
          <!-- NOTE (b-addMehvar) to add new mehvar -->
          <b-button variant="success" @click="openAdd3()" class="my-2"
            ><strong>افزودن محور جدید +</strong></b-button
          >
          <v-row
            class="header-box btn-radius pa-1 ps-2"
            style="margin: 0 1px 25px"
          >
            <v-col>
              <h4 style="margin-top: 9px">محور‌ها</h4>
            </v-col>
            <v-col>
              <v-btn
                class="bc-primary text-white btn-radius float-end"
                width="200"
                height="45"
                elevation="0"
                :disabled="isBusy3 || !items1.length"
                @click="$refs.table3.$el.click()"
              >
                <span class="fs-small">
                  خروجی اکسل

                  <v-icon>$Excel</v-icon></span
                >
              </v-btn>
              <vue-excel-xlsx
                v-show="false"
                ref="table3"
                :data="items3"
                :columns="excelFields3"
                :filename="'لیست محور ها'"
                :sheetname="currentDate"
              >
                دریافت اکسل
              </vue-excel-xlsx>
            </v-col>
          </v-row>
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="filter3"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  :disabled="!filter3"
                  @click="filter3 = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-mehvars) to show the mehvars list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields3"
            :items="items3"
            :current-page="currentPage3"
            :per-page="perPage3"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="isBusy3"
            :filter="filter3"
            @filtered="onFiltered3"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage3 * (currentPage3 - 1) + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  width: 150px;
                  margin: auto;
                "
              >
                <!-- NOTE (b-editMehvar) to edit mevar -->
                <b-button
                  style="width: 100%"
                  variant="warning"
                  @click="openEdit3(data.item)"
                  >ویرایش</b-button
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage3"
            :total-rows="totalRows3"
            :per-page="perPage3"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
      </b-tabs>
    </b-card>
    <router-view></router-view>
    <b-modal id="add1" ref="add1">
      <h4>افزودن رسته جدید</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="نام رسته"
          v-model="newRaste"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input
          trim
          placeholder="توضیحات"
          v-model="newRasteDesc"
        ></b-form-input>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-btn :disabled="!newRaste" variant="success" @click="doAdd1()"
          >افزودن</b-btn
        >
      </template>
    </b-modal>
    <b-modal id="add2" ref="add2">
      <h4>افزودن موضوع جدید</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="نام موضوع"
          v-model="newMozou"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="رسته مربوطه">
        <b-form-select
          :options="
            items1.map((x) => {
              return {
                value: x.id,
                text: x.name,
              };
            })
          "
          v-model="newMozouRaste"
        ></b-form-select>
      </b-form-group>
      <template v-slot:modal-footer>
        <!-- NOTE (b-addMehvar2) previous -->
        <b-button
          :disabled="!newMozou || !newMozouRaste"
          variant="success"
          @click="doAdd2()"
          >افزودن</b-button
        >
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      id="add3"
      ref="add3"
      tabindex="0"
      style="overflow: hidden"
    >
      <h4>افزودن محور جدید</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="نام محور"
          v-model="newMehvar"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="موضوع مربوطه">
        <v-select
          dir="rtl"
          :reduce="(x) => x.code"
          :options="
            items2.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          "
          v-model="newMehvarMozou"
        >
        </v-select>
      </b-form-group>
      <b-form-group label="دانشگاه مربوطه">
        <v-select
          dir="rtl"
          :reduce="(x) => x.code"
          :options="universities"
          v-model="newMehvarUniversity"
        >
        </v-select>
      </b-form-group>
      <b-form-group>
        <b-form-input
          trim
          placeholder="شماره تفاهم‌نامه"
          v-model="newMehvarNumber"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="تاریخ تفاهم‌نامه">
        <date-picker color="#7b1fa2" v-model="newMehvarDate"></date-picker>
      </b-form-group>
      <template v-slot:modal-footer>
        <!-- NOTE (b-addMehvar3) previous -->
        <b-button :disabled="!newMehvar" variant="success" @click="doAdd3()"
          >افزودن</b-button
        >
      </template>
    </b-modal>
    <b-modal id="edit1" ref="edit1">
      <h4>ویرایش رسته</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="نام رسته"
          v-model="selected.name"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input
          trim
          placeholder="توضیحات"
          v-model="selected.description"
        ></b-form-input>
      </b-form-group>
      <template v-slot:modal-footer>
        <!-- NOTE (b-editRasteh2) previous -->
        <b-button
          :disabled="!selected.name"
          variant="success"
          @click="doEdit1()"
          >ثبت تغییرات</b-button
        >
      </template>
    </b-modal>
    <b-modal id="edit2" ref="edit2">
      <h4>ویرایش موضوع</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="نام موضوع"
          v-model="selected.name"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="رسته مربوطه">
        <b-form-select
          :options="
            items1.map((x) => {
              return {
                value: x.id,
                text: x.name,
              };
            })
          "
          v-model="selected.mainCatId"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="وضعیت">
        <b-form-select v-model="selected.status" :options="states">
        </b-form-select>
      </b-form-group>
      <template v-slot:modal-footer>
        <!-- NOTE (b-editSubject2) previous -->
        <b-button
          :disabled="!selected.name || !selected.mainCatId"
          variant="success"
          @click="doEdit2()"
          >ثبت تغییرات</b-button
        >
      </template>
    </b-modal>
    <b-modal no-close-on-backdrop id="edit3" ref="edit3">
      <h4>ویرایش محور</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="نام محور"
          v-model="selected.name"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="موضوع مربوطه">
        <!-- <Select2
          v-model="selected.catId"
          :options="
            items2.map(x => {
              return {
                id: x.id,
                text: x.name
              };
            })"
          :settings="{ width: '100%' }"
        ></Select2>  -->
        <v-select
          dir="rtl"
          :reduce="(x) => x.code"
          :options="
            items2.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          "
          v-model="selected.catId"
        >
        </v-select>
        <!-- <model-select
          :options="            
            items2.map(x => {
              return {
                value: x.id,
                text: x.name
              };
            })"
            v-model="selected.catId"
            style="text-align:right"> 
         </model-select>-->
      </b-form-group>
      <b-form-group label="دانشگاه مربوطه">
        <v-select
          dir="rtl"
          :reduce="(x) => x.code"
          :options="universities"
          v-model="selected.universityId"
        >
        </v-select>
      </b-form-group>
      <b-form-group label="وضعیت">
        <b-form-select v-model="selected.status" :options="states">
        </b-form-select>
      </b-form-group>
      <b-form-group>
        <b-form-input
          trim
          placeholder="شماره تفاهم‌نامه"
          v-model="selected.contractNo"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="تاریخ تفاهم‌نامه">
        <date-picker color="#7b1fa2" v-model="selected.date"></date-picker>
      </b-form-group>
      <template v-slot:modal-footer>
        <!-- NOTE (b-editMehvar4) previous -->
        <b-button
          :disabled="!selected.name"
          variant="success"
          @click="doEdit3()"
          >ثبت تغییرات</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
import Select2 from "v-select2-component";
import { ModelSelect } from "vue-search-select";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    Select2,
    ModelSelect,
  },
  data: function () {
    return {
      perPage1: 10,
      currentPage1: 1,
      totalRows1: 1,
      perPage2: 10,
      currentPage2: 1,
      totalRows2: 1,
      perPage3: 10,
      currentPage3: 1,
      totalRows3: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),

      fields1: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "رسته" },
        { key: "description", label: "توضیحات" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "name", label: "رسته" },
        { field: "description", label: "توضیحات" },
      ],
      items1: [],
      filter1: "",
      isBusy1: true,
      fields2: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "موضوع" },
        { key: "mainCat", label: "رسته" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields2: [
        { field: "name", label: "موضوع" },
        { field: "mainCat", label: "رسته" },
      ],
      items2: [],
      filter2: "",
      isBusy2: true,
      states: [
        { value: "فعال", eng: "active", text: "فعال" },
        { value: "غیرفعال", eng: "deactive", text: "غیرفعال" },
      ],
      fields3: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "محور" },
        { key: "cat", label: "موضوع" },
        { key: "university", label: "نام دانشگاه" },
        { key: "contractNo", label: "شماره تفاهم‌نامه" },
        { key: "date", label: "تاریخ قرارداد" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields3: [
        { field: "name", label: "محور" },
        { field: "cat", label: "موضوع" },
        { field: "university", label: "نام دانشگاه" },
        { field: "contractNo", label: "شماره تفاهم‌نامه" },
        { field: "date", label: "تاریخ قرارداد" },
        { field: "status", label: "وضعیت" },
      ],
      items3: [],
      filter3: "",
      isBusy3: true,
      newRaste: "",
      newRasteDesc: "",
      newMozou: "",
      newMozouRaste: "",
      newMehvar: "",
      newMehvarMozou: "",
      newMehvarUniversity: "",
      newMehvarNumber: "",
      newMehvarDate: "",
      universities: [],
      selected: {},
    };
  },

  methods: {
    getData() {
      // NOTE (m-getData) to get the data of this page
      this.$http
        .post(
          this.baseUrl + "/setad/admin/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data.map((x) => {
            return {
              code: x.id,
              label: x.text,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });

      this.$http
        .post(
          this.baseUrl + "/setad/admin/mainCats/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items1 = res.data;
          this.isBusy1 = false;
          this.totalRows1 = this.items1.length;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });

      this.$http
        .post(
          this.baseUrl + "/setad/admin/cats/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items2 = res.data;
          this.totalRows2 = this.items2.length;
          this.isBusy2 = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });

      this.$http
        .post(
          this.baseUrl + "/setad/admin/mehvars/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items3 = res.data;
          this.isBusy3 = false;
          this.totalRows3 = this.items3.length;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    onFiltered2(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows2 = filteredItems.length;
      this.currentPage2 = 1;
    },
    onFiltered3(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows3 = filteredItems.length;
      this.currentPage3 = 1;
    },
    openAdd1() {
      // NOTE (m-openAdd1) to show loading
      this.$refs["add1"].show();
    },
    doAdd1() {
      // NOTE (m-doAdd1) to add new rasteh
      this.$http
        .post(
          this.baseUrl + "/setad/admin/mainCat/new",
          {
            name: this.newRaste,
            description: this.newRasteDesc,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy1 = true;
          this.toast(res.data, "success");
          this.newRaste = "";
          this.newRasteDesc = "";
          this.$refs["add1"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openEdit1(item) {
      // NOTE (m-openEdit1) to specify selected rasteh
      this.selected = JSON.parse(JSON.stringify(item));
      this.$refs["edit1"].show();
    },
    doEdit1() {
      // NOTE (m-doEdit1) to edit the rasteh
      this.$http
        .post(
          this.baseUrl + "/setad/admin/mainCat/edit",
          {
            mainCatId: this.selected.id,
            name: this.selected.name,
            description: this.selected.description,
            status: "active",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy1 = true;
          this.toast(res.data, "success");
          this.selected = {};
          this.$refs["edit1"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openDelete(item) {
      this.selected = item;
      this.$refs["doDel"].show();
    },
    openAdd2() {
      // NOTE (m-openAdd2) to show loading
      this.$refs["add2"].show();
    },
    doAdd2() {
      // NOTE (m-doAdd2) to add new subject
      this.$http
        .post(
          this.baseUrl + "/setad/admin/cat/new",
          {
            name: this.newMozou,
            mainCatId: this.newMozouRaste,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy2 = true;
          this.toast(res.data, "success");
          this.newMozou = "";
          this.newMozouRaste = "";
          this.$refs["add2"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openEdit2(item) {
      // NOTE (m-openEdit2) to specify selected subject
      this.selected = JSON.parse(JSON.stringify(item));
      this.$refs["edit2"].show();
    },
    doEdit2() {
      // NOTE (m-doEdit2) to edit subject
      this.$http
        .post(
          this.baseUrl + "/setad/admin/cat/edit",
          {
            catId: this.selected.id,
            name: this.selected.name,
            mainCatId: this.selected.mainCatId,
            status: this.states.filter(
              (x) => x.value == this.selected.status
            )[0].eng,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy2 = true;
          this.toast(res.data, "success");
          this.selected = {};
          this.$refs["edit2"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openAdd3() {
      // NOTE (m-openAdd3) to show loading
      this.$refs["add3"].show();
    },
    doAdd3() {
      // NOTE (m-doAdd3) to add new subject
      this.$http
        .post(
          this.baseUrl + "/setad/admin/mehvar/new",
          {
            catId: this.newMehvarMozou,
            name: this.newMehvar,
            contractDate: this.newMehvarDate,
            contractNumber: this.newMehvarNumber,
            universityId: this.newMehvarUniversity,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          (this.newMehvar = ""),
            (this.newMehvarMozou = ""),
            (this.newMehvarNumber = ""),
            (this.newMehvarDate = "");
          this.isBusy3 = true;
          this.toast(res.data, "success");
          this.newMehvar = "";
          this.$refs["add3"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openEdit3(item) {
      // NOTE (m-openEdit3) to specify selected mehvar
      this.selected = JSON.parse(JSON.stringify(item));
      this.selected.catId = this.selected.catId;
      this.selected.universityId = this.selected.universityId;
      this.$refs["edit3"].show();
    },
    doEdit3() {
      // NOTE (m-doEdit3) to edit mehvar
      this.$http
        .post(
          this.baseUrl + "/setad/admin/mehvar/edit",
          {
            mehvarId: this.selected.id,
            catId: this.selected.catId,
            name: this.selected.name,
            contractDate: this.selected.date,
            contractNumber: this.selected.contractNo,
            universityId: this.selected.universityId,
            status: this.states.filter(
              (x) => x.value == this.selected.status
            )[0].eng,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy3 = true;
          this.toast(res.data, "success");
          this.selected = {};
          this.$refs["edit3"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    hideModal(type) {
      this.$refs[type].hide();
    },
  },

  mounted() {
    // NOTE (MOUNTED) to show the data of this page
    this.getData();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
.select2-search__field {
  z-index: 20000;
}
</style>
